/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum StandardPriceSourceEnum {
    DP_REFERENCE = 'DP_REFERENCE',
    DP_REFERENCE_MODIFIED = 'DP_REFERENCE_MODIFIED',
    PHARMAPHOTO2 = 'PHARMAPHOTO2',
    LABO_MASTER = 'LABO_MASTER',
    CUSTOMER = 'CUSTOMER',
    PHARMACY_SW = 'PHARMACY_SW',
    STANDARD_PRICE_PRICELIST = 'STANDARD_PRICE_PRICELIST',
    PROVIDOM_PRICELIST = 'PROVIDOM_PRICELIST',
    NO_PRICE_AVAILABLE = 'NO_PRICE_AVAILABLE',
}